import styled from 'styled-components/macro';

export const LoaderWrapper = styled.div`
  width: 100%;
  margin: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
